module.exports = __webpack_public_path__ + "static/media/VEVA-Cube-Glow (copy).135db007.png";